import { roundMinor } from './money';
export const DOCTOR_DISCOUNT_KINDS = ['fixed', 'percent'];
export function doctorDiscountPerUnit(rule, unitPriceMinor) {
    if (!rule || !(unitPriceMinor > 0) || !(rule.discountValue > 0))
        return 0;
    const cut = rule.discountKind === 'percent' ? roundMinor((unitPriceMinor * Math.min(rule.discountValue, 100)) / 100) : roundMinor(rule.discountValue);
    return Math.max(0, Math.min(unitPriceMinor, cut));
}
export function doctorDiscountMinor(rule, unitPriceMinor, qty) {
    const units = Number.isFinite(qty) && qty > 0 ? qty : 0;
    return roundMinor(doctorDiscountPerUnit(rule, unitPriceMinor) * units);
}
export function doctorPriceMinor(rule, unitPriceMinor) {
    return unitPriceMinor - doctorDiscountPerUnit(rule, unitPriceMinor);
}
//# sourceMappingURL=doctor-discount.js.map